import { Action, actionCreators } from "../actions";

export interface Store {
    number: string;
    isVisible: boolean;
}

export function initialStore(): Store {
    return {
        number: "",
        isVisible: false,
    };
}

export function update(store = initialStore(), action: Action): Store {
    switch (action.type) {
        case actionCreators.onLogout.type:
        case actionCreators.onWrongToken.type: {
            return initialStore();
        }

        case actionCreators.dialpadSetText.type: {
            const { payload: text } = action;
            return { ...store, number: text };
        }

        case actionCreators.selectRosterView.type: {
            const { elementId } = action.payload;
            return { ...store, isVisible: elementId === "external" ? false : store.isVisible };
        }

        case actionCreators.toggleRosterDialpad.type: {
            return { ...store, isVisible: !store.isVisible };
        }

        default: {
            return store;
        }
    }
}

export type OuterStore = { dialpad: Store };

export function isDialpadVisible(store: OuterStore) {
    return store.dialpad.isVisible;
}

export function getNumber(store: OuterStore) {
    return store.dialpad.number;
}
